import { lazy } from 'react';
export var EvaluationsPageAsync = lazy(function () { return import('./EvaluationsPage'); });
